import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useContext } from "react";
import NestedSideMenu from "../../components/NestedSideMenu";
import UserContext from "../../contexts/UserContext";
import MerchantContext from "../../contexts/MerchantContext";
import { PORTAL_CODES_MERCHANT_ID } from "../../utils/permissions";
import { useIsMobile } from "@/hooks/useMediaQuery";

type ConfigItem = {
  path: string;
  label: string;
  palommaOnly?: boolean;
  developmentOnly?: boolean;
  merchantOnly?: string;
};

const configItems: ConfigItem[] = [
  { path: "/configuration/pipeline", label: "Estados" },
  { path: "/configuration/agents", label: "Agentes", palommaOnly: true },
  { path: "/configuration/projects", label: "Proyectos", palommaOnly: true, developmentOnly: true },
  { path: "/configuration/lead-qualification", label: "Calificación de Leads" },
  { path: "/configuration/integrations", label: "Integraciones" },
  { path: "/configuration/assignment", label: "Asignación" },
  { path: "/configuration/whatsapp", label: "WhatsApp" },
  { path: "/configuration/templates", label: "Plantillas de WhatsApp" },
  { path: "/configuration/users", label: "Usuarios" },
  { path: "/configuration/schedules", label: "Horarios para Citas" },
  { path: "/configuration/inbound-campaign-rules", label: "Pauta" },
  { path: "/configuration/auditoria", label: "Auditoría" },
  {
    path: "/configuration/portal-codes",
    label: "Códigos de Portales",
    merchantOnly: PORTAL_CODES_MERCHANT_ID,
  },
];

const ConfigurationLayout = () => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const location = useLocation();
  const { hasPalommaOnlyAccess: isPalommaUser } = useContext(UserContext);
  const { merchantType, merchantId } = useContext(MerchantContext);
  const isDevelopment = merchantType === "development";

  const filteredItems = configItems.filter((item) => {
    if (item.palommaOnly && !isPalommaUser) return false;
    if (item.developmentOnly && !isDevelopment) return false;
    if (item.merchantOnly && merchantId !== item.merchantOnly) return false;
    return true;
  });

  return (
    <div className="flex flex-col md:flex-row">
      {isMobile ? (
        <div className="border-b border-gray-200 bg-white px-4 py-3">
          <select
            value={location.pathname}
            onChange={(e) => navigate(e.target.value)}
            className="w-full rounded-md border border-gray-200 px-3 py-2 font-semibold focus:border-palomma-primary focus:outline-none focus:ring-1 focus:ring-palomma-primary"
          >
            {filteredItems.map((item) => (
              <option key={item.path} value={item.path}>
                {item.label}
              </option>
            ))}
          </select>
        </div>
      ) : (
        <NestedSideMenu />
      )}
      <div className="min-w-0 grow">
        <Outlet />
      </div>
    </div>
  );
};

export default ConfigurationLayout;
